import { History, Search } from 'lucide-react'
import { GroupWrapper } from '../GroupWrapper'
import { ItemWrapper } from '../ItemWrapper'
import { RecentSearch } from '../../types/search'
import { Avatar, AvatarImage } from '@wellesley/ui'

const RecentIcon = ({ avatarSrc }: { avatarSrc?: string }) => {
  return (
    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gray-100">
      {avatarSrc ? (
        <Avatar>
          <AvatarImage src={avatarSrc} alt="group-avatar" />
        </Avatar>
      ) : (
        <History size={20} className="text-gray-500" />
      )}
    </div>
  )
}

type RecentItemProps = {
  search: RecentSearch
  onSearchClick: (search: RecentSearch) => void
}

const RecentItem = ({ search, onSearchClick }: RecentItemProps) => {
  if (search.type === 'group') {
    return (
      <ItemWrapper onClick={() => onSearchClick(search)}>
        <RecentIcon avatarSrc={search.avatarSrc} />
        in: {search.title} {search.searchValue ? `: ${search.searchValue}` : ''}
      </ItemWrapper>
    )
  }

  return (
    <ItemWrapper onClick={() => onSearchClick(search)}>
      <RecentIcon />
      {search.value}
    </ItemWrapper>
  )
}

type RecentSearchesProps = {
  searches: RecentSearch[]
  onSearchClick: (search: RecentSearch) => void
}

export const RecentSearches = ({
  searches,
  onSearchClick,
}: RecentSearchesProps) => {
  if (searches.length === 0)
    return (
      <div className="flex items-center gap-xxs p-xxs">
        <div className="flex size-m flex-shrink-0 items-center justify-center rounded-full bg-white">
          <Search size={20} className="text-gray-500" />
        </div>
        <div className="flex flex-col">
          <h3 className="text-base font-medium text-gray-900">
            No recent searches
          </h3>
          <p className="text-sm text-gray-500">
            Try searching to see them here
          </p>
        </div>
      </div>
    )

  return (
    <GroupWrapper>
      <h2 className="text-lg font-semibold text-gray-900 max-md:pl-xs max-md:text-sm max-md:font-medium max-md:text-gray-500">
        Recent searches
      </h2>
      {searches.map((search, index) => (
        <RecentItem key={index} search={search} onSearchClick={onSearchClick} />
      ))}
    </GroupWrapper>
  )
}
